import React from 'react';
import styles from '../Operations.module.css';

interface CRPCComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * CRPC - Critical Pricing Issues*
 * KPI information component
 */
const CRPC: CRPCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        The average Ace store loses over $22,000 annually because retails are below suggested retail or cost. The Assortment and Pricing section of the Retail Analytics dashboard allows retailers to quickly see and take action on these items to reclaim lost profit and margin.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Why is Critical Retail Pricing important to your store?  
      </div>

      <div style={{ marginLeft: '20px', marginBottom: '15px' }}>
        • It brings underpriced products you&apos;re losing money on to the forefront<br/>
        • It exposes items in MAPP violation, helping to ensure compliance<br/>
        • View Ace&apos;s recommended prices against your store pricing, and other key data points to aid in making pricing decisions<br/>
        • Allows you to take swift and effective responses to time-sensitive pricing issues
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Critical Pricing Issues is &lt;200 SKU count/store
      </div>

       <div className={styles.sectionTitle}>
        Drill Down 
      </div>

      <div className={styles.sectionContent}>
        Links to your SKUs with pricing issues 
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div style={{ marginLeft: '20px' }}>
        1. Review Ace Way of Retailing documentation on{' '}
        <a 
          href="https://acenet.aceservices.com/awor/retail-pricing/ace-pricing" 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.link}
        >
          Retail Pricing
        </a>
        <br/>
        2. Take the new{' '}
        <a 
          href="https://acehardware.sabacloud.com/Saba/Web_spf/NA9P1PRD003/app/me/learningeventdetail/cours000000000449299;spf-url=common%2Fledetail%2Fcours000000000449299" 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.link}
        >
          microlearning Critical Pricing Retail Training Course
        </a>
        {' '}(visit the Ace LearningPlace and search for &quot;Critical Pricing&quot;)
      </div>
    </div>
  );
};

CRPC.title = 'Critical Retail Pricing';
CRPC.kpiHyperlink = 'dynamicURL:ACENET:description';
CRPC.actionTitle = 'REVIEW PRICING ISSUES';
CRPC.actionHyperlink = 'dynamicURL:ACENET:current';
export default CRPC;

